import { nanoid } from 'nanoid';
import { concurrencyLimiter } from '@utils/queue/concurrencyUtils';

export const CONCURRENT_QUERY_LIMIT = 3;

export const buildWidgetConfig = ({ type, state }) => {
  return {
    wid: nanoid(),
    type,
    state,
  };
};

export const buildQueryConfig = () => {
  return {
    concurrencyLimiter: concurrencyLimiter(CONCURRENT_QUERY_LIMIT),
    status: {},
  };
};
